
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/filter",
      function () {
        return require("private-next-pages/filter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/filter"])
      });
    }
  